import * as TagCategory from 'types/BaseIngredient/Search/TagCategory';
import * as Icon from 'types/Icon/Icon';

export type Type = {
	display: boolean;
	iconSvgUrl: string | null;
	id: string;
	name: string;
	tagCategory: TagCategory.Type;
};

export function create(): Type {
	return {
		display: false,
		iconSvgUrl: null,
		id: '',
		name: '',
		tagCategory: TagCategory.create(),
	};
}

export function mapToIcon(obj: Type): Icon.Type | null {
	if (obj.display) {
		return {
			name: obj.name,
			iconSvgUrl: obj.iconSvgUrl,
		};
	}
	return null;
}
